
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Dashboard</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a>Dashboards</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="region &amp;&amp; region.toUpperCase() !== 'WW'"><a [routerLink]="['/projects']" [queryParams]="{search: 'region:'+region}">{{ region.toUpperCase() }} Projects</a></li>
        <li class="breadcrumb-item" *ngIf="projectId"><a [routerLink]="['/project']" [queryParams]="{id: projectId}">{{ title }}</a></li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row" *ngIf="!error">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col col-md-10">
            <h2>{{ dashboardData.title }}</h2>
            <div class="card-progress-bar">
              <div class="progress">
                <div class="progress-bar" role="progressbar" title="{{ dashboardData.deployedPercentageBar?.title }}" [ngClass]="dashboardData.deployedPercentageBar?.type" [style.width]="dashboardData.deployedPercentageBar?.width + '%'">{{dashboardData.deployedPercentageBar?.value + "%"}}</div>
              </div>
            </div>
          </div>
          <div class="col-3 col-md-2"><b>Date:</b><br>{{ dashboardData.currentDate }}</div>
        </div>
        <hr>
        <div class="row" *ngIf="!disableBudgetDisplay">
          <div class="col-md-4">Transition budget: {{ dashboardData.totalBudget | number:'1.2-2' }} {{ dashboardData.currency }}</div>
          <div class="col-md-4">Actual expenses: {{ dashboardData.totalExpenses | number:'1.2-2'}} {{ dashboardData.currency }}</div>
          <div class="col-md-4">TCV($M): {{ dashboardData.totalCustomerValue/1000000.0 | number:'1.2-5' }}</div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">DART Devices: {{ dashboardData.totalAssets }}</div>
          <div class="col-md-4">Assets sent to ITSM: {{ dashboardData.installed }}</div>
          <div class="col-md-4" *ngIf="!disableBudgetDisplay">Total revenue: {{ dashboardData.totalRevenue | number:'1.2-5' }}</div>
        </div>
        <div class="row mt-2" *ngIf="projectId">
          <div class="col-md-4">Projected Start: {{ project?.startDate | date: 'yyyy-MM-dd': 'UTC'}}</div>
          <div class="col-md-4">Completion Date: {{ project?.estimatedCompletionDate | date: 'yyyy-MM-dd': 'UTC'}}</div>
        </div>
        <div class="row mt-2" *ngIf="dashboardData.overBudget">
          <div class="col-12">
            <property-container class="red">
              <property-item><span class="oi oi-dollar"></span> {{ dashboardData.overBudgetMessage }}</property-item>
            </property-container>
          </div>
        </div>
        <div class="row mt-2" *ngIf="dashboardData.pastSchedule">
          <div class="col-12">
            <property-container class="red">
              <property-item><span class="oi oi-clock"></span> {{ dashboardData.pastScheduleMessage }}</property-item>
            </property-container>
          </div>
        </div>
        <hr *ngIf="projectId">
        <div class="row" *ngIf="projectId">
          <div class="col-12">
            <h6>Transition Lead(s):</h6><span *ngFor="let user of dashboardData.TCUsers; let last = last">{{ user.firstName }} {{ user.lastName }}{{ last ? '' : ', ' }}</span>
          </div>
        </div>
        <hr *ngIf="projects.length">
        <div class="row" *ngIf="projects.length">
          <div class="col-12">
            <h6>Projects:</h6><a *ngFor="let project of projects; let last = last" [routerLink]="['/dashboard']" [queryParams]="{projectId: project?.id}">{{ project?.name }}{{ last ? '' : ', ' }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="projectId &amp;&amp; !error">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col-lg-5">
            <h4>Milestones</h4>
            <list-display [listStructure]="milestoneData"></list-display>
          </div>
          <div class="col-lg-7">
            <h4>Risks & Issues</h4>
            <list-display [listStructure]="dashboardIssueData"></list-display>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!error">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col-6">
            <h4>Device Forecast</h4>
            <table class="table table-responsive text-center">
              <thead>
                <tr>
                  <th rowspan="2"></th>
                  <th class="align-middle" rowspan="2">Total to be Deployed</th>
                  <th colspan="3">Already Deployed</th>
                  <th class="align-middle" *ngIf="projectId" rowspan="2">Freeze</th>
                </tr>
                <tr>
                  <th>Total</th>
                  <th>New</th>
                  <th>MAI</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-right">Single Function</th>
                  <td>{{ dashboardData.toBeDeploySF }}</td>
                  <td>{{ dashboardData.totalDeployedSF }}</td>
                  <td>{{ dashboardData.deployedSFNew }}</td>
                  <td>{{ dashboardData.deployedSFMai }}</td>
                  <td *ngIf="projectId">{{ dashboardData.forecastFreeze?.sf }}</td>
                </tr>
                <tr>
                  <th class="text-right">Multi Function</th>
                  <td>{{ dashboardData.toBeDeployMF }}</td>
                  <td>{{ dashboardData.totalDeployedMF }}</td>
                  <td>{{ dashboardData.deployedMFNew }}</td>
                  <td>{{ dashboardData.deployedMFMai }}</td>
                  <td *ngIf="projectId">{{ dashboardData.forecastFreeze?.mf }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-6">
            <h4>Planned Devices/Deployments</h4>
            <table class="table table-responsive text-center">
              <thead>
                <tr>
                  <th></th>
                  <th>{{ dashboardData.billingStart }}-{{ dashboardData.billingEnd }}</th>
                  <th>Current Quarter</th>
                  <th>Next Quarter</th>
                </tr>
                <tr class="planned-table-columns"></tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-right">Devices SF</th>
                  <td>{{ dashboardData.monthPlannedDevicesSF }}</td>
                  <td>{{ dashboardData.q1PlannedDevicesSF }}</td>
                  <td>{{ dashboardData.q2PlannedDevicesSF }}</td>
                </tr>
                <tr>
                  <th class="text-right">Devices MF</th>
                  <td>{{ dashboardData.monthPlannedDevicesMF }}</td>
                  <td>{{ dashboardData.q1PlannedDevicesMF }}</td>
                  <td>{{ dashboardData.q2PlannedDevicesMF }}</td>
                </tr>
                <tr>
                  <th class="text-right">Deployments</th>
                  <td>{{ dashboardData.monthPlannedDeployments }}</td>
                  <td>{{ dashboardData.q1PlannedDeployments }}</td>
                  <td>{{ dashboardData.q2PlannedDeployments }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>